import { nodeGeometry } from './graphGeometry.js';

/**
 * Snap lines for dragging node `nodeId`, as in EEZ Studio's flow editor: the
 * left/centre/right and top/middle/bottom of the other nodes, of the UI
 * objects wired to the node, and of the page. Coordinates are in the graph
 * layer's space; the result has the shape of SnapManager.collectSnapTargets.
 *
 * @param {object} input
 * @param {object} input.graph
 * @param {string} input.nodeId     the node being dragged
 * @param {{x,y}}  input.origin     page origin in layer coordinates
 * @param {object} input.domain     provides getNodeSchema and nodeSize
 * @param {Array}  input.objects    [{ uuid, rect }] UI objects in layer coordinates
 * @param {{width,height}} [input.pageSize]
 */
export function graphSnapTargets({ graph, nodeId, origin, domain, objects, pageSize = null }) {
    const vertical = [];
    const horizontal = [];
    const addRect = bounds => {
        [bounds.x, bounds.x + bounds.width / 2, bounds.x + bounds.width].forEach(pos => vertical.push({ pos, bounds }));
        [bounds.y, bounds.y + bounds.height / 2, bounds.y + bounds.height].forEach(pos => horizontal.push({ pos, bounds }));
    };

    for (const node of graph.nodes) {
        if (node.id !== nodeId) addRect(nodeGeometry(node, origin, domain).rect);
    }

    const wired = new Set();
    for (const wire of graph.wires) {
        if (wire.from.node === nodeId && wire.to.object !== undefined) wired.add(wire.to.object);
        if (wire.to.node === nodeId && wire.from.object !== undefined) wired.add(wire.from.object);
    }
    for (const object of objects) {
        if (wired.has(object.uuid)) addRect(object.rect);
    }

    if (pageSize) addRect({ x: origin.x, y: origin.y, width: pageSize.width, height: pageSize.height });
    return { vertical, horizontal };
}
